import React from "react";
const FooterBanner = () => {
  return (
    <div
      className="h-[100%] w-full"
      style={{
        backgroundImage: "url(/footer-banner-bg.png)",
        backgroundSize: "100% 80%",
        backgroundPosition: "bottom",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex flex-col justify-between items-center">
        <div className="flex flex-col justify-center items-center mb-4">
          <h2 className="text-primary-white text-4xl font-semibold">
            هرحال دا، هر دیل ده، هر سلیقه ده، هر یئرده
          </h2>
          <h3 className="text-[#B21F1F] text-4xl mt-2">منه باخ</h3>
        </div>
        <div className="">
          <img src="/footer-banner-main.png" loading="lazy" alt="منه باخ" />
        </div>
      </div>
    </div>
  );
};

export default FooterBanner;
